import React, { useState } from "react";
import "../../index.css";
import "./OurValue.css";

const ourValues = [
  {
    letter: "I",
    text: "INTEGRITY",
    description:
      "Integrity is the foundation of every relationship and decision we make. We are committed to acting honestly, transparently, and fairly, upholding high professional ethics. Through integrity, we build trust with colleagues, partners, and customers.",
  },
  {
    letter: "G",
    text: "GROWTH",
    description:
      "We are committed to continuous growth, both as individuals and as an organization. We encourage ongoing learning, adapting to challenges, and developing new skills. Growth is key to facing change and reaching our full potential in every aspect of our professional lives.",
  },
  {
    letter: "N",
    text: "NETWORK",
    description:
      "We believe that strong relationships are the cornerstone of long-term success. Through a broad network, we support one another, share knowledge, and create new opportunities. We prioritize collaboration and synergy to strengthen our position in the market and community.",
  },
  {
    letter: "I",
    text: "INNOVATION",
    description:
      "Innovation is key to staying relevant and competitive. We foster a culture of creativity and forward-thinking to find new solutions that meet evolving needs. We are always looking for ways to improve efficiency, quality, and customer experience.",
  },
  {
    letter: "T",
    text: "TEAMWORK",
    description:
      "We believe that a strong team is the foundation of success. By valuing each other's expertise and roles, we work together to achieve common goals. We create a collaborative environment where every team member can contribute their best.",
  },
  {
    letter: "E",
    text: "EXCELLENCE",
    description:
      "We are committed to delivering the best results in everything we do. Excellence is not just about meeting standards, but exceeding expectations. We continually strive for higher performance, innovating to achieve perfection and delivering outstanding results.",
  },
];

const OurValuePage = () => {
  const [hoverData, setHoverData] = useState(ourValues[0]); // State to track hover value
  const [activeIndex, setActiveIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true); // Visibility state for hover-data

  const handleMouseEnter = (data, index) => {
    setHoverData(data);
    setIsVisible(true);
    setActiveIndex(index);
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
    setActiveIndex(null);
  };

  return (
    <>
      <div className="layout our-value-layout gradient-background">
        <div className="container value-container">
          <div className="letter-value-container">
            <div className="text-value-container">
              <div className="title value-title">OUR VALUES</div>
              <ul className="value-list">
                {ourValues.map((value, index) => (
                  <li
                    key={`${value.letter}-${index}`} // Ensure uniqueness
                    className={`hover-item ${
                      activeIndex === index ? "active" : ""
                    }`}
                    onMouseEnter={() => handleMouseEnter(value, index)}
                    onMouseLeave={handleMouseLeave}
                  >
                    <div
                      className={`value-letter ${
                        activeIndex === index ? "big-letter" : ""
                      }`}
                    >
                      {value.letter}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div
              className="hover-data"
              style={{
                opacity: 1,
                pointerEvents: "default",
              }}
            >
              {hoverData.text && (
                <div className="title hover-data-letter">{hoverData.text}</div>
              )}
              {hoverData.description && (
                <div className="subtitle hover-data-subtitle">
                  {hoverData.description}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurValuePage;
